interface APIValidationError {
  [key: string]: {
    message: string;
    name: string;
    path: string[];
    type: string;
  };
}

interface APIValidationResponse {
  data: {
    msg: string;
    errors: APIValidationError;
  };
}

/**
 * Maps API Validation errors to error object. API Validation path is joined using dot (.)
 * Message is already translated from the API side, DO NOT TRANSLATE
 *
 */
export default function handleAPIValidationErrors(apiResponse: APIValidationResponse, errorSetter, existingErrors) {
  const apiValidationErrors = apiResponse?.data?.errors;

  if (!apiValidationErrors) {
    return;
  }

  const validationErrors = Object.values(apiValidationErrors);
  const newErrors = {};

  validationErrors.forEach((validationError) => {
    const errorKey = validationError.path.join('.');

    newErrors[errorKey] = validationError.message;
  });

  errorSetter({
    ...existingErrors,
    ...newErrors,
  });
}
